module.exports = __webpack_public_path__ + "img/tubo galvanizado.7ece31fa.jpg";